import {
  AccountFragment,
  Amount,
  CurrencyType,
  DetailedOrderFragment,
} from 'src/graphql'

const creditCardRequired = (
  order: Pick<DetailedOrderFragment, 'cost'>,
  account: Pick<AccountFragment, 'points' | 'expense'>,
  credits: Amount,
  isUsingCredits: boolean,
) => {
  for (const { currency, amount } of order.cost.total) {
    if (currency === CurrencyType.FREE) {
      return false
    } else if (
      currency === CurrencyType.POINT &&
      amount > account.points.amount
    ) {
      return true
    } else if (
      currency === CurrencyType.EXPENSE &&
      amount > account.expense.amount
    ) {
      return true
    } else if (isUsingCredits && currency === CurrencyType.USD) {
      return amount > credits.amount
    } else if (currency === CurrencyType.USD) {
      return true
    }
  }
  return false
}

export default creditCardRequired
